import React, { useState } from "react"
import "./BasePage.scss"
import cn from "classnames"
import { useSelector } from "react-redux"
import { settingsSelectors } from "@/slices/settingsSlice"
import { logOut } from "@/services/authService"

interface IBasePageProps {
  title: string
  children: React.ReactNode
  className: string
  topRightContent?: React.ReactNode
  showHeaderImages?: boolean
}

export function BasePage({
  title,
  children,
  className,
  topRightContent,
  showHeaderImages,
}: IBasePageProps) {
  const [logoutClicks, setLogoutClicks] = useState(0)

  const settings = useSelector(settingsSelectors.settings)
  return (
    <div className={cn("base-page", className)}>
      <div className="base-page__header">
        {showHeaderImages && (
          <div
            className="base-page__header-theme base-page__header-theme--left"
            onClick={() => {
              if (logoutClicks % 2 === 0) {
                setLogoutClicks(logoutClicks + 1)
                setTimeout(() => {
                  setLogoutClicks(0)
                }, 5000)
              }
            }}
          >
            {(settings?.themeType === "marinaBirthday" ||
              settings?.themeType === "christianBirthday") && (
              <>
                <img className="base-page__theme-flag1" src="/images/dk-flag-mirror.png" />
              </>
            )}
            {settings?.themeType === "christmas" && (
              <>
                <img className="base-page__theme-tree" src="/images/christmas_tree.gif" />
              </>
            )}
          </div>
        )}
        <h1>{title}</h1>
        {showHeaderImages && (
          <div
            className="base-page__header-theme base-page__header-theme--right"
            onClick={() => {
              if (logoutClicks % 2 === 1) {
                if (logoutClicks === 3) {
                  logOut()
                } else {
                  setLogoutClicks(logoutClicks + 1)
                }
              }
            }}
          >
            {(settings?.themeType === "marinaBirthday" ||
              settings?.themeType === "christianBirthday") && (
              <>
                <img className="base-page__theme-flag2" src="/images/dk-flag.png" />
              </>
            )}
            {settings?.themeType === "christmas" && (
              <>
                <img className="base-page__theme-tree" src="/images/christmas_tree.gif" />
              </>
            )}
          </div>
        )}
        {!!topRightContent && <div className="base-page__top-right">{topRightContent}</div>}
      </div>
      <div className="base-page-container">{children}</div>
    </div>
  )
}
